import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBusinessTypeFeatures = () => {
  const { data: ownerData } = useQuery({
    queryKey: ["ownerData"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("No user found");

      // If user is an owner_user, use their reference_owner_id instead
      const ownerId = user.user_metadata?.reference_owner_id || user.id;

      const { data, error } = await supabase
        .from("owner_data")
        .select(`
          *,
          business_types (
            id,
            name,
            features
          )
        `)
        .eq("owner_id", ownerId)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
  });

  const businessTypeFeatures = ownerData?.business_types?.features || {};

  const hasFeatureAccess = (feature: string) => {
    if (!businessTypeFeatures) return true; // Par défaut, autoriser si aucune restriction n'est définie
    return businessTypeFeatures[feature] !== false;
  };

  return {
    businessTypeFeatures,
    hasFeatureAccess,
  };
};